var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6586 22H10.6171C10.1091 22 9.6958 21.5866 9.6958 21.0784V14.2154H7.9213C7.41327 14.2154 7 13.8019 7 13.2938V10.353C7 9.8448 7.41327 9.43137 7.9213 9.43137H9.6958V7.95874C9.6958 6.49857 10.1541 5.25628 11.0211 4.36638C11.892 3.47242 13.109 3 14.5407 3L16.8603 3.00377C17.3675 3.00464 17.78 3.41806 17.78 3.92542V6.65585C17.78 7.16408 17.3669 7.5775 16.859 7.5775L15.2972 7.57808C14.8209 7.57808 14.6996 7.67361 14.6737 7.70289C14.6309 7.75145 14.5801 7.88873 14.5801 8.26779V9.43123H16.7416C16.9043 9.43123 17.062 9.47138 17.1975 9.54705C17.4898 9.71042 17.6715 10.0193 17.6715 10.3532L17.6703 13.2939C17.6703 13.8019 17.257 14.2153 16.749 14.2153H14.5801V21.0784C14.5801 21.5866 14.1667 22 13.6586 22Z",
    fill: "#B1BFB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b1fa477f6c69740a7fa42186cfa3e97a.svg";
export { ForwardRef as ReactComponent };